import { useTranslations } from "next-intl";
import Image from "next/image";
import React from "react";

const Hero = () => {
  const t = useTranslations("careersHeader");
  return (
    <div className="  grid grid-cols-12 space-y-[40px] lg:space-y-0 lg:gap-x-20 mt-10 mb-[74px] md:mt-[34px] lg:mb-9">
      {/* join our team start */}
      <div className="space-y-[20px] col-span-12 lg:col-span-6 mx-auto lg:mx-0 ">
        <h3 className="h-12 md:h-10  text-[32px] md:text-[40px] flex items-center font-[590] text-[#010140]">
          {t("title")}
        </h3>
        <p className="text-[16px] md:text-[18px] xsm:leading-[21px] md:leading-[26px] text-[#010140] ">
          {t("text")}
        </p>
      </div>
      {/* join our team end */}

      {/* side image start */}
      <div className="col-span-12 lg:col-span-6  w-full h-fit sm:pr-3 pt-3 lg:ml-auto mx-auto lg:mx-0 max-w-[472px]">
        <div className="relative  min-w-[200px]">
          <div className="mx-auto max-w-full h-[200px] sm:h-[260px] mds:h-[329px]  w-[452px]  ">
            <Image
              src={"/career/Career.png"}
              alt={"career"}
              layout="fill"
              objectFit="cover"
              className="rounded-[10px]"
            />
          </div>

          <div className=" absolute h-[138px] sm:h-[183px] w-[138px] sm:w-[183px] z-[-10] top-[-9px] md:top-[-12px] right-[-9px] md:right-[-12px]">
            <Image
              src={"/career/border.png"}
              layout="fill"
              alt="ascot website careers"
            />
          </div>

          <div className=" absolute h-[55%] md:h-[183px] w-[183px] z-[-10] bottom-[-9px] md:bottom-[-12px] left-[-9px] md:left-[-12px]">
            <Image
             src={"/career/border.png"}
              layout="fill"
              alt="ascot website careers"
               />
          </div>
        </div>
      </div>
      {/* side image end */}
    </div>
  );
};

export default Hero;
